import _toArray from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import _toConsumableArray from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import { Connector, __privateAdd, __privateGet, __privateMethod, __privateSet, __publicField } from "./chunk-5NCTPR6C.js"; // src/walletConnect.ts

import { SwitchChainError, UserRejectedRequestError, getClient } from "@wagmi/core";
import { providers } from "ethers";
import { getAddress, hexValue } from "ethers/lib/utils.js";
var NAMESPACE = "eip155";
var REQUESTED_CHAINS_KEY = "wagmi.requestedChains";
var ADD_ETH_CHAIN_METHOD = "wallet_addEthereumChain";

var _provider, _initProviderPromise, _createProvider, createProvider_fn, _initProvider, initProvider_fn, _isChainsStale, isChainsStale_fn, _setupListeners, setupListeners_fn, _removeListeners, removeListeners_fn, _setRequestedChainsIds, setRequestedChainsIds_fn, _getRequestedChainsIds, getRequestedChainsIds_fn, _getNamespaceChainsIds, getNamespaceChainsIds_fn, _getNamespaceMethods, getNamespaceMethods_fn;

var WalletConnectConnector = /*#__PURE__*/function (_Connector) {
  _inherits(WalletConnectConnector, _Connector);

  var _super = _createSuper(WalletConnectConnector);

  function WalletConnectConnector(config) {
    var _this;

    _classCallCheck(this, WalletConnectConnector);

    _this = _super.call(this, _objectSpread(_objectSpread({}, config), {}, {
      options: _objectSpread({
        isNewChainsStale: true
      }, config.options)
    }));

    __privateAdd(_assertThisInitialized(_this), _createProvider);

    __privateAdd(_assertThisInitialized(_this), _initProvider);

    __privateAdd(_assertThisInitialized(_this), _isChainsStale);

    __privateAdd(_assertThisInitialized(_this), _setupListeners);

    __privateAdd(_assertThisInitialized(_this), _removeListeners);

    __privateAdd(_assertThisInitialized(_this), _setRequestedChainsIds);

    __privateAdd(_assertThisInitialized(_this), _getRequestedChainsIds);

    __privateAdd(_assertThisInitialized(_this), _getNamespaceChainsIds);

    __privateAdd(_assertThisInitialized(_this), _getNamespaceMethods);

    __publicField(_assertThisInitialized(_this), "id", "walletConnect");

    __publicField(_assertThisInitialized(_this), "name", "WalletConnect");

    __publicField(_assertThisInitialized(_this), "ready", true);

    __privateAdd(_assertThisInitialized(_this), _provider, void 0);

    __privateAdd(_assertThisInitialized(_this), _initProviderPromise, void 0);

    __publicField(_assertThisInitialized(_this), "onAccountsChanged", function (accounts) {
      if (accounts.length === 0) _this.emit("disconnect");else _this.emit("change", {
        account: getAddress(accounts[0])
      });
    });

    __publicField(_assertThisInitialized(_this), "onChainChanged", function (chainId) {
      var id = Number(chainId);

      var unsupported = _this.isChainUnsupported(id);

      _this.emit("change", {
        chain: {
          id: id,
          unsupported: unsupported
        }
      });
    });

    __publicField(_assertThisInitialized(_this), "onDisconnect", function () {
      __privateMethod(_assertThisInitialized(_this), _setRequestedChainsIds, setRequestedChainsIds_fn).call(_assertThisInitialized(_this), []);

      _this.emit("disconnect");
    });

    __publicField(_assertThisInitialized(_this), "onDisplayUri", function (uri) {
      _this.emit("message", {
        type: "display_uri",
        data: uri
      });
    });

    __publicField(_assertThisInitialized(_this), "onConnect", function () {
      _this.emit("connect", {
        provider: __privateGet(_assertThisInitialized(_this), _provider)
      });
    });

    __privateMethod(_assertThisInitialized(_this), _createProvider, createProvider_fn).call(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(WalletConnectConnector, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _ref,
            chainId,
            pairingTopic,
            targetChainId,
            _this$chains$,
            lastUsedChainId,
            provider,
            isChainsStale,
            optionalChains,
            accounts,
            account,
            id,
            unsupported,
            _args = arguments;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, chainId = _ref.chainId, pairingTopic = _ref.pairingTopic;
                _context.prev = 1;
                targetChainId = chainId;

                if (!targetChainId) {
                  lastUsedChainId = getClient().lastUsedChainId;
                  if (lastUsedChainId && !this.isChainUnsupported(lastUsedChainId)) targetChainId = lastUsedChainId;else targetChainId = (_this$chains$ = this.chains[0]) === null || _this$chains$ === void 0 ? void 0 : _this$chains$.id;
                }

                if (targetChainId) {
                  _context.next = 6;
                  break;
                }

                throw new Error("No chains found on connector.");

              case 6:
                _context.next = 8;
                return this.getProvider();

              case 8:
                provider = _context.sent;

                __privateMethod(this, _setupListeners, setupListeners_fn).call(this);

                isChainsStale = __privateMethod(this, _isChainsStale, isChainsStale_fn).call(this);

                if (!(provider.session && isChainsStale)) {
                  _context.next = 14;
                  break;
                }

                _context.next = 14;
                return provider.disconnect();

              case 14:
                if (!(!provider.session || isChainsStale)) {
                  _context.next = 20;
                  break;
                }

                optionalChains = this.chains.filter(function (chain) {
                  return chain.id !== targetChainId;
                }).map(function (optionalChain) {
                  return optionalChain.id;
                });
                this.emit("message", {
                  type: "connecting"
                });
                _context.next = 19;
                return provider.connect({
                  pairingTopic: pairingTopic,
                  chains: [targetChainId],
                  optionalChains: optionalChains
                });

              case 19:
                __privateMethod(this, _setRequestedChainsIds, setRequestedChainsIds_fn).call(this, this.chains.map(function (_ref2) {
                  var id2 = _ref2.id;
                  return id2;
                }));

              case 20:
                _context.next = 22;
                return provider.enable();

              case 22:
                accounts = _context.sent;
                account = getAddress(accounts[0]);
                _context.next = 26;
                return this.getChainId();

              case 26:
                id = _context.sent;
                unsupported = this.isChainUnsupported(id);
                return _context.abrupt("return", {
                  account: account,
                  chain: {
                    id: id,
                    unsupported: unsupported
                  },
                  provider: new providers.Web3Provider(provider)
                });

              case 31:
                _context.prev = 31;
                _context.t0 = _context["catch"](1);

                if (!/user rejected/i.test(_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message)) {
                  _context.next = 35;
                  break;
                }

                throw new UserRejectedRequestError(_context.t0);

              case 35:
                throw _context.t0;

              case 36:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 31]]);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var provider;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getProvider();

              case 2:
                provider = _context2.sent;
                _context2.prev = 3;
                _context2.next = 6;
                return provider.disconnect();

              case 6:
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](3);

                if (/No matching key/i.test(_context2.t0.message)) {
                  _context2.next = 12;
                  break;
                }

                throw _context2.t0;

              case 12:
                _context2.prev = 12;

                __privateMethod(this, _removeListeners, removeListeners_fn).call(this);

                __privateMethod(this, _setRequestedChainsIds, setRequestedChainsIds_fn).call(this, []);

                return _context2.finish(12);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 8, 12, 16]]);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "getAccount",
    value: function () {
      var _getAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _yield$this$getProvid, accounts;

        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getProvider();

              case 2:
                _yield$this$getProvid = _context3.sent;
                accounts = _yield$this$getProvid.accounts;
                return _context3.abrupt("return", getAddress(accounts[0]));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAccount() {
        return _getAccount.apply(this, arguments);
      }

      return getAccount;
    }()
  }, {
    key: "getChainId",
    value: function () {
      var _getChainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _yield$this$getProvid2, chainId;

        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getProvider();

              case 2:
                _yield$this$getProvid2 = _context4.sent;
                chainId = _yield$this$getProvid2.chainId;
                return _context4.abrupt("return", chainId);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getChainId() {
        return _getChainId.apply(this, arguments);
      }

      return getChainId;
    }()
  }, {
    key: "getProvider",
    value: function () {
      var _getProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _ref3,
            chainId,
            _args5 = arguments;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _ref3 = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {}, chainId = _ref3.chainId;

                if (__privateGet(this, _provider)) {
                  _context5.next = 4;
                  break;
                }

                _context5.next = 4;
                return __privateMethod(this, _createProvider, createProvider_fn).call(this);

              case 4:
                if (!chainId) {
                  _context5.next = 7;
                  break;
                }

                _context5.next = 7;
                return this.switchChain(chainId);

              case 7:
                return _context5.abrupt("return", __privateGet(this, _provider));

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getProvider() {
        return _getProvider.apply(this, arguments);
      }

      return getProvider;
    }()
  }, {
    key: "getSigner",
    value: function () {
      var _getSigner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _ref4,
            chainId,
            _yield$Promise$all,
            _yield$Promise$all2,
            provider,
            account,
            _args6 = arguments;

        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _ref4 = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {}, chainId = _ref4.chainId;
                _context6.next = 3;
                return Promise.all([this.getProvider({
                  chainId: chainId
                }), this.getAccount()]);

              case 3:
                _yield$Promise$all = _context6.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                provider = _yield$Promise$all2[0];
                account = _yield$Promise$all2[1];
                return _context6.abrupt("return", new providers.Web3Provider(provider, chainId).getSigner(account));

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getSigner() {
        return _getSigner.apply(this, arguments);
      }

      return getSigner;
    }()
  }, {
    key: "isAuthorized",
    value: function () {
      var _isAuthorized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _yield$Promise$all3, _yield$Promise$all4, account, provider, isChainsStale;

        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return Promise.all([this.getAccount(), this.getProvider()]);

              case 3:
                _yield$Promise$all3 = _context7.sent;
                _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
                account = _yield$Promise$all4[0];
                provider = _yield$Promise$all4[1];
                isChainsStale = __privateMethod(this, _isChainsStale, isChainsStale_fn).call(this);

                if (account) {
                  _context7.next = 10;
                  break;
                }

                return _context7.abrupt("return", false);

              case 10:
                if (!(isChainsStale && provider.session)) {
                  _context7.next = 19;
                  break;
                }

                _context7.prev = 11;
                _context7.next = 14;
                return provider.disconnect();

              case 14:
                _context7.next = 18;
                break;

              case 16:
                _context7.prev = 16;
                _context7.t0 = _context7["catch"](11);

              case 18:
                return _context7.abrupt("return", false);

              case 19:
                return _context7.abrupt("return", true);

              case 22:
                _context7.prev = 22;
                _context7.t1 = _context7["catch"](0);
                return _context7.abrupt("return", false);

              case 25:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 22], [11, 16]]);
      }));

      function isAuthorized() {
        return _isAuthorized.apply(this, arguments);
      }

      return isAuthorized;
    }()
  }, {
    key: "switchChain",
    value: function () {
      var _switchChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(chainId) {
        var chain, provider, namespaceChains, namespaceMethods, isChainApproved, _chain$blockExplorers, requestedChains, message;

        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                chain = this.chains.find(function (chain2) {
                  return chain2.id === chainId;
                });

                if (chain) {
                  _context8.next = 3;
                  break;
                }

                throw new SwitchChainError(new Error("chain not found on connector."));

              case 3:
                _context8.prev = 3;
                _context8.next = 6;
                return this.getProvider();

              case 6:
                provider = _context8.sent;
                namespaceChains = __privateMethod(this, _getNamespaceChainsIds, getNamespaceChainsIds_fn).call(this);
                namespaceMethods = __privateMethod(this, _getNamespaceMethods, getNamespaceMethods_fn).call(this);
                isChainApproved = namespaceChains.includes(chainId);

                if (!(!isChainApproved && namespaceMethods.includes(ADD_ETH_CHAIN_METHOD))) {
                  _context8.next = 16;
                  break;
                }

                _context8.next = 13;
                return provider.request({
                  method: ADD_ETH_CHAIN_METHOD,
                  params: [{
                    chainId: hexValue(chain.id),
                    blockExplorerUrls: [(_chain$blockExplorers = chain.blockExplorers) === null || _chain$blockExplorers === void 0 ? void 0 : _chain$blockExplorers.default],
                    chainName: chain.name,
                    nativeCurrency: chain.nativeCurrency,
                    rpcUrls: _toConsumableArray(chain.rpcUrls.default.http)
                  }]
                });

              case 13:
                requestedChains = __privateMethod(this, _getRequestedChainsIds, getRequestedChainsIds_fn).call(this);
                requestedChains.push(chainId);

                __privateMethod(this, _setRequestedChainsIds, setRequestedChainsIds_fn).call(this, requestedChains);

              case 16:
                _context8.next = 18;
                return provider.request({
                  method: "wallet_switchEthereumChain",
                  params: [{
                    chainId: hexValue(chainId)
                  }]
                });

              case 18:
                return _context8.abrupt("return", chain);

              case 21:
                _context8.prev = 21;
                _context8.t0 = _context8["catch"](3);
                message = typeof _context8.t0 === "string" ? _context8.t0 : _context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message;

                if (!/user rejected request/i.test(message)) {
                  _context8.next = 26;
                  break;
                }

                throw new UserRejectedRequestError(_context8.t0);

              case 26:
                throw new SwitchChainError(_context8.t0);

              case 27:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[3, 21]]);
      }));

      function switchChain(_x) {
        return _switchChain.apply(this, arguments);
      }

      return switchChain;
    }()
  }]);

  return WalletConnectConnector;
}(Connector);

_provider = new WeakMap();
_initProviderPromise = new WeakMap();
_createProvider = new WeakSet();

createProvider_fn = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!__privateGet(this, _initProviderPromise) && typeof window !== "undefined") {
              __privateSet(this, _initProviderPromise, __privateMethod(this, _initProvider, initProvider_fn).call(this));
            }

            return _context9.abrupt("return", __privateGet(this, _initProviderPromise));

          case 2:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function createProvider_fn() {
    return _ref5.apply(this, arguments);
  };
}();

_initProvider = new WeakSet();

initProvider_fn = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    var _yield$import, EthereumProvider, OPTIONAL_EVENTS, OPTIONAL_METHODS, _this$chains$map, _this$chains$map2, defaultChain, optionalChains, _this$options, projectId, _this$options$showQrM, showQrModal, qrModalOptions;

    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return import("@walletconnect/ethereum-provider");

          case 2:
            _yield$import = _context10.sent;
            EthereumProvider = _yield$import.default;
            OPTIONAL_EVENTS = _yield$import.OPTIONAL_EVENTS;
            OPTIONAL_METHODS = _yield$import.OPTIONAL_METHODS;
            _this$chains$map = this.chains.map(function (_ref7) {
              var id = _ref7.id;
              return id;
            }), _this$chains$map2 = _toArray(_this$chains$map), defaultChain = _this$chains$map2[0], optionalChains = _this$chains$map2.slice(1);

            if (!defaultChain) {
              _context10.next = 16;
              break;
            }

            _this$options = this.options, projectId = _this$options.projectId, _this$options$showQrM = _this$options.showQrModal, showQrModal = _this$options$showQrM === void 0 ? true : _this$options$showQrM, qrModalOptions = _this$options.qrModalOptions;
            _context10.t0 = __privateSet;
            _context10.t1 = this;
            _context10.t2 = _provider;
            _context10.next = 14;
            return EthereumProvider.init({
              showQrModal: showQrModal,
              qrModalOptions: qrModalOptions,
              projectId: projectId,
              optionalMethods: OPTIONAL_METHODS,
              optionalEvents: OPTIONAL_EVENTS,
              chains: [defaultChain],
              optionalChains: optionalChains,
              rpcMap: Object.fromEntries(this.chains.map(function (chain) {
                return [chain.id, chain.rpcUrls.default.http[0]];
              }))
            });

          case 14:
            _context10.t3 = _context10.sent;
            (0, _context10.t0)(_context10.t1, _context10.t2, _context10.t3);

          case 16:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));

  return function initProvider_fn() {
    return _ref6.apply(this, arguments);
  };
}();

_isChainsStale = new WeakSet();

isChainsStale_fn = function isChainsStale_fn() {
  var namespaceMethods = __privateMethod(this, _getNamespaceMethods, getNamespaceMethods_fn).call(this);

  if (namespaceMethods.includes(ADD_ETH_CHAIN_METHOD)) return false;
  if (!this.options.isNewChainsStale) return false;

  var requestedChains = __privateMethod(this, _getRequestedChainsIds, getRequestedChainsIds_fn).call(this);

  var connectorChains = this.chains.map(function (_ref8) {
    var id = _ref8.id;
    return id;
  });

  var namespaceChains = __privateMethod(this, _getNamespaceChainsIds, getNamespaceChainsIds_fn).call(this);

  if (namespaceChains.length && !namespaceChains.some(function (id) {
    return connectorChains.includes(id);
  })) return false;
  return !connectorChains.every(function (id) {
    return requestedChains.includes(id);
  });
};

_setupListeners = new WeakSet();

setupListeners_fn = function setupListeners_fn() {
  if (!__privateGet(this, _provider)) return;

  __privateMethod(this, _removeListeners, removeListeners_fn).call(this);

  __privateGet(this, _provider).on("accountsChanged", this.onAccountsChanged);

  __privateGet(this, _provider).on("chainChanged", this.onChainChanged);

  __privateGet(this, _provider).on("disconnect", this.onDisconnect);

  __privateGet(this, _provider).on("session_delete", this.onDisconnect);

  __privateGet(this, _provider).on("display_uri", this.onDisplayUri);

  __privateGet(this, _provider).on("connect", this.onConnect);
};

_removeListeners = new WeakSet();

removeListeners_fn = function removeListeners_fn() {
  if (!__privateGet(this, _provider)) return;

  __privateGet(this, _provider).removeListener("accountsChanged", this.onAccountsChanged);

  __privateGet(this, _provider).removeListener("chainChanged", this.onChainChanged);

  __privateGet(this, _provider).removeListener("disconnect", this.onDisconnect);

  __privateGet(this, _provider).removeListener("session_delete", this.onDisconnect);

  __privateGet(this, _provider).removeListener("display_uri", this.onDisplayUri);

  __privateGet(this, _provider).removeListener("connect", this.onConnect);
};

_setRequestedChainsIds = new WeakSet();

setRequestedChainsIds_fn = function setRequestedChainsIds_fn(chains) {
  localStorage.setItem(REQUESTED_CHAINS_KEY, JSON.stringify(chains));
};

_getRequestedChainsIds = new WeakSet();

getRequestedChainsIds_fn = function getRequestedChainsIds_fn() {
  var data = localStorage.getItem(REQUESTED_CHAINS_KEY);
  return data ? JSON.parse(data) : [];
};

_getNamespaceChainsIds = new WeakSet();

getNamespaceChainsIds_fn = function getNamespaceChainsIds_fn() {
  var _privateGet$session, _privateGet$session$n, _privateGet$session$n2;

  if (!__privateGet(this, _provider)) return [];
  var chainIds = (_privateGet$session = __privateGet(this, _provider).session) === null || _privateGet$session === void 0 ? void 0 : (_privateGet$session$n = _privateGet$session.namespaces[NAMESPACE]) === null || _privateGet$session$n === void 0 ? void 0 : (_privateGet$session$n2 = _privateGet$session$n.chains) === null || _privateGet$session$n2 === void 0 ? void 0 : _privateGet$session$n2.map(function (chain) {
    return parseInt(chain.split(":")[1] || "");
  });
  return chainIds !== null && chainIds !== void 0 ? chainIds : [];
};

_getNamespaceMethods = new WeakSet();

getNamespaceMethods_fn = function getNamespaceMethods_fn() {
  var _privateGet$session2, _privateGet$session2$;

  if (!__privateGet(this, _provider)) return [];
  var methods = (_privateGet$session2 = __privateGet(this, _provider).session) === null || _privateGet$session2 === void 0 ? void 0 : (_privateGet$session2$ = _privateGet$session2.namespaces[NAMESPACE]) === null || _privateGet$session2$ === void 0 ? void 0 : _privateGet$session2$.methods;
  return methods !== null && methods !== void 0 ? methods : [];
};

export { WalletConnectConnector };